// extracted by mini-css-extract-plugin
module.exports = {"CardWrapper":"gJ2lPKacrpzmmpl680L4yQ=="};